<template>
  <div>
    <avue-crud ref="table" :data="tableData" :page.sync="page" :option="tableOption" :table-loading="tableLoading" :search.sync="search" @search-change="onLoad" @on-load="onLoad">
      <!-- <template slot="menuLeft">
        <el-button size="small" class="dis-b" type="primary" @click="addPay">缴纳</el-button>
      </template> -->
      <template slot-scope="scope" slot="amount"> ￥{{ scope.row.amount | numConvertToThousandths }}元 </template>
      <template slot-scope="{ row }" slot="attachment_id">
        <form-file v-if="row.attachment_id" :disabled="true" :value="row.attachment_id"></form-file>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <template v-if="tenantId == '000000'">
          <el-button type="text" size="small" icon="el-icon-delete" v-if="row.status == 1 || row.status == 8" @click="rowDel(row.id)">删除</el-button>
          <el-button type="text" size="small" icon="el-icon-tickets" v-if="row.status != 8 && row.pay_atta_ids == null" @click="refund(row.id, '1')">退款补录</el-button>
          <el-button type="text" size="small" icon="el-icon-coordinate" v-if="row.status != 8 && row.is_invoice == '1'" @click="refund(row.id, '2')">开票</el-button>
        </template>
        <el-button type="text" size="small" icon="el-icon-collection-tag" v-if="row.process_instance_id" @click="viewProcessInstance(row)">审批记录</el-button>
      </template>
    </avue-crud>
    <el-drawer :visible.sync="todoDrawer" :size="400" :withHeader="false" append-to-body>
      <el-container v-if="todoDrawer" class="h-100p">
        <el-header class="bor-b" height="50px">
          <el-page-header class="lh-50" @back="todoDrawer = false" content="审批记录"></el-page-header>
        </el-header>
        <el-main class="pad-15">
          <TodoTask :id="currentRow.process_instance_id"></TodoTask>
        </el-main>
      </el-container>
    </el-drawer>

    <!-- 支付信息Dialog -->
    <el-dialog title="缴纳费用" :visible.sync="show" width="40%" append-to-body>
      <el-alert v-if="form.paymentType === 6" :closable="false" show-icon class="mar-b-10" title="温馨提示" type="warning" description="如果缴款方式选择【B2B企业支付】未找到相关银行，请选择【线下银行转账】并填写相关信息"> </el-alert>
      <el-form ref="form" :model="form" size="small" label-width="120px">
        <el-form-item :rules="[{ required: true, message: '请选择缴纳方式', trigger: 'blur' }]" label="缴纳方式" prop="paymentType">
          <el-radio-group v-model="form.paymentType" @change="paymentTypeChange">
            <!-- 企业用户B2B支付选项 -->
            <el-radio :label="6" v-if="isCompany">B2B企业支付</el-radio>
            <el-radio :label="4" v-else>现金</el-radio>
            <el-radio :label="5">线下银行转账</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 现金支付 -->
        <el-form-item v-if="form.paymentType === 4" :rules="[{ required: true, message: '请输入缴纳金额', trigger: 'blur' }]" label="缴纳金额" prop="money">
          <el-input v-model.number="form.money" type="number" placeholder="请输入金额"></el-input>
        </el-form-item>
        <!-- 线下银行转账 -->
        <template v-if="form.paymentType === 5">
          <el-form-item label="银行" prop="accountBank">
            <el-select class="dis-b" v-model="form.accountBank" filterable>
              <el-option v-for="item of bankList" :key="item.id" :label="item.dictValue" :value="item.dictKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :rules="[{ required: true, message: '请输入缴纳金额', trigger: 'blur' }]" label="缴纳金额" prop="money">
            <el-input v-model="form.money" type="number" placeholder="请输入缴纳金额"></el-input>
          </el-form-item>
          <el-form-item label="缴费开户行" prop="depositBank">
            <el-input v-model="form.depositBank" type="text" placeholder="请输入缴费开户行"></el-input>
          </el-form-item>
          <el-form-item label="缴费账号" prop="account">
            <el-input v-model="form.account" type="text" placeholder="请输入缴费账号"></el-input>
          </el-form-item>
          <el-form-item label="缴费时间" prop="payTime" :rules="[{ required: true, message: '请选择缴费时间', trigger: 'blur' }]">
            <el-date-picker v-model="form.payTime" type="datetime" placeholder="请选择缴费时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="凭证编号" prop="serialNumber">
            <el-input v-model="form.serialNumber" type="text" placeholder="请输入凭证编号"></el-input>
          </el-form-item>
          <el-form-item label="凭证附件" prop="attachmentId">
            <form-file v-model="form.attachmentId" :multiple="false"></form-file>
          </el-form-item>
          <el-form-item label="备注" prop="note">
            <el-input v-model="form.note" type="textarea" placeholder="请输入备注"></el-input>
          </el-form-item>
        </template>

        <!-- 企业用户线上B2B支付 -->
        <template v-if="form.paymentType === 6">
          <el-form-item label-width="0px">
            <el-table :data="payList" border @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center"> </el-table-column>
              <el-table-column label="费用科目" prop="feeName"></el-table-column>
              <el-table-column label="应缴费用" width="120" prop="amountReceivable"></el-table-column>
              <el-table-column label="实缴费用" width="120" prop="amountReceived"></el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label-width="0px">
            <div>
              选中<span class="mar-lr-3 text-blue">{{ form.ids.length }}</span> 笔费用，共<span class="mar-lr-3 text-blue">￥{{ form.amount || 0 }}</span
              >元
            </div>
          </el-form-item>
        </template>

        <el-form-item class="mar-t-40 text-right">
          <el-button size="small" @click="show = false" :loading="saveLoading">取消</el-button>
          <el-button size="small" @click="savePay" :loading="saveLoading" type="primary">确认支付</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 补录退款信息dialog -->
    <el-dialog :title="actionType == '1' ? '退款信息' : '开票信息'" :visible.sync="showRefundDialog" width="40%" append-to-body :destroy-on-close="true">
      <el-form ref="refundForm" :model="refundForm" size="small" label-width="120px">
        <template v-if="actionType == '1'">
          <el-form-item label="退款附件" prop="pay_atta_ids" :rules="[{ required: true, message: '请上传附件', trigger: 'blur' }]">
            <form-file v-model="refundForm.pay_atta_ids" :multiple="true"></form-file>
          </el-form-item>
          <el-form-item label="退款备注" prop="pay_remark" :rules="[{ required: true, message: '请输入信息', trigger: 'blur' }]">
            <el-input v-model="refundForm.pay_remark" type="textarea" placeholder="请输入备注"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="开票日期" prop="invoice_date" :rules="[{ required: true, message: '请选择开票日期', trigger: 'blur' }]">
            <el-date-picker v-model="refundForm.invoice_date" type="date" placeholder="请选择开票日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </template>
        <el-form-item class="mar-t-40 text-right">
          <el-button size="small" @click="handleCancle()">取消</el-button>
          <el-button size="small" @click="handleConfirm()" type="primary">确认提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import TodoTask from "@/views/flow/todo-task.vue"
import { getMetaCommonList, updateMetaCommon, delMetaCommon } from "@/api/busiMode/metaCommon"
import { addPay, b2bPay, getNeedPayItem, calculatePay } from "@/api/finance/index.js"
import { getDictionary } from "@/api/system/dictbiz.js"

import * as dictService from "@/api/system/dictbiz"
export default {
  components: { TodoTask },
  data() {
    return {
      todoDrawer: false,
      model: "wisdom_park.wp_payment",
      tableLoading: false,
      tableData: [],
      search: {},
      page: {
        pageSizes: this.$store.state.common.pageSizes,
        pagerCount: this.$store.state.common.pagerCount,
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      tableOption: {
        height: "250px",
        labelPosition: "top",
        searchMenuPosition: "right",
        searchMenuSpan: 24,
        border: true,
        delBtn: false,
        editBtn: false,
        addBtn: false,
        viewBtn: true,
        menu: true,
        menuWidth: 160,
        header: true,
        refreshBtn: false,
        columnBtn: false,
        column: [
          {
            label: "支付方式",
            prop: "payment_type",
            dataType: "number",
            dicUrl: dictService.getUrl("PayType"),
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            width: 110,
            type: "select",
            disabled: true,
          },
          {
            label: "状态",
            prop: "status",
            width: 100,
            dataType: "number",
            dicUrl: dictService.getUrl("PayStatus"),
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            type: "select",
            display: false,
          },
          {
            label: "实收金额",
            prop: "amount",
            width: 150,
          },
          {
            label: "创建时间",
            prop: "create_time",
            width: 150,
          },
          {
            label: "缴费成功时间",
            prop: "success_time",
            width: 150,
          },
          {
            label: "开票时间",
            prop: "invoice_date",
            width: 150,
          },
          {
            label: "第三方流水号",
            prop: "serial_number",
            width: 150,
          },
          {
            label: "缴费账号",
            prop: "account",
            width: 150,
          },
          {
            label: "缴费银行",
            prop: "account_bank",
            width: 150,
            dicUrl: dictService.getUrl("BankType"),
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            type: "select",
          },
          {
            label: "缴费开户行",
            prop: "deposit_bank",
          },
          {
            label: "附件",
            prop: "attachment_id",
            width: 150,
            component: "form-file",
            span: 24,
            placeholder: " ",
          },
          {
            label: "退款信息附件",
            prop: "pay_atta_ids",
            width: 150,
            component: "form-file",
            span: 24,
            placeholder: " ",
          },
          {
            label: "退款信息备注",
            prop: "pay_remark",
            span: 24,
            minWidth: 200,
          },
          {
            label: "备注",
            prop: "note",
            span: 24,
            minWidth: 200,
          },
        ],
      },
      currentRow: null,
      show: false,
      form: {
        paymentType: 5,
        money: null,
        serialNumber: "",
        accountBank: "",
        depositBank: "",
        account: "",
        attachmentId: "",
        payTime: "",
        note: "",
        ids: [], //企业B2B支付时，存储选中的账单条目
      },
      saveLoading: false,
      /** 当前账单已录入的支付信息 */
      payList: [],
      /** 可选的银行列表 */
      bankList: [],
      /** 补录退款信息 */
      refundForm: {
        id: "",
        pay_atta_ids: "",
        pay_remark: "",
        invoice_date: "",
      },
      showRefundDialog: false,
      actionType: "1",
      tenantId: "000000",
    }
  },
  props: {
    receiptNo: {
      type: String,
      default: "",
    },
    receiptStatus: {
      type: Number,
      default: 0,
    },
    approvalStatus: {
      type: Number,
      default: 1,
    },
    isCompany: {
      type: Boolean,
      default: true,
    },
    processInstanceId: {
      type: String,
      default: "",
    },
    isTodo: {
      type: Boolean,
      default: false,
    },
    paidAmount: {
      type: String | Number,
      default: "",
    },
  },

  mounted() {
    if (this.isCompany) {
      this.getCompanyPayList()
      this.form.paymentType = 6
    }

    this.getBankList()
    this.tenantId = this.$store.state.user.tenantId
    if (this.tenantId == "000000") {
      this.tableOption.menuWidth = 280
    }
  },
  methods: {
    getBankList() {
      getDictionary({ code: "BankType" }).then((res) => {
        this.bankList = res.data.data || []
      })
    },
    // 获取企业需要缴费信息
    getCompanyPayList() {
      getNeedPayItem({ receiptNo: this.receiptNo }).then((res) => {
        this.payList = res.data.data
      })
    },
    viewProcessInstance(row) {
      this.currentRow = row
      this.todoDrawer = true
    },
    onLoad() {
      this.tableLoading = true
      this.tableData = []
      let wheres = [
        { field: "receipt_no", value: this.receiptNo },
        { field: "status", value: [1, 2, 3, 5, 6, 8], op: "IN" },
      ]
      if (this.isTodo) {
        wheres.push({
          field: "process_instance_id",
          value: this.processInstanceId,
        })
      }
      getMetaCommonList(this.model, {
        current: this.page.currentPage,
        size: this.page.pageSize,
        wheres: wheres,
      })
        .then((res) => {
          this.tableLoading = false
          this.tableData = res.data.data.records
          this.page.total = res.data.data.total
        })
        .catch((e) => {
          this.tableLoading = false
        })
    },
    rowDel(id) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delMetaCommon(this.model, { pk: "id", ids: [id] }).then(() => {
          this.onLoad()
          this.$message({
            type: "success",
            message: "操作成功!",
          })
        })
      })
    },

    addPay() {
      this.show = true
    },

    paymentTypeChange() {
      if (this.form.paymentType == 4) {
        this.form.money = Number(this.paidAmount)
      } else {
        this.form.money = null
      }
    },
    /** 确认支付 */
    savePay() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.paymentType == 6 ? this.savePayForB2B() : this.savePayForMoneyOrBank()
        }
      })
    },
    /**
     * 校验数据：本次提交的金额不可超过 待缴纳金额 - （已录入）待审批金额
     */
    checkPay() {
      if (this.form.money <= this.paidAmount) {
        let wheres = [
          { field: "receipt_no", value: this.receiptNo },
          { field: "status", value: 1 },
          // { field: "approval_status", value: 4 },
        ]
        getMetaCommonList("wisdom_park.wp_payment", { size: 10, wheres }).then((res) => {
          if (res.data.success) {
            let n = 0
            for (let i = 0; i++; i < res.data.data.records.length) {
              n += res.data.data.records[i].amount
            }
            if (n + this.form.money > this.paidAmount) {
              return Promise.reject(fasle)
            } else {
              return Promise.resolve(true)
            }
          }
        })
      } else {
        this.$message.error("支付金额超出待缴纳金额")
      }
    },

    /** 现金及线下银行转账支付提交 */
    savePayForMoneyOrBank() {
      if (this.form.money && this.form.money > 0) {
        this.saveLoading = true
        addPay({ receiptNo: this.receiptNo, ...this.form })
          .then((res) => {
            if (res.data.success) {
              this.success()
            }
          })
          .catch((e) => {
            this.saveLoading = false
          })
      } else {
        this.$message.error("金额有误")
      }
    },

    /**
     * 监听企业B2B缴费时的选中数据时的数据处理
     * @param  rows
     */
    handleSelectionChange(rows) {
      let ids = []
      ids = rows.map((item) => item.id)
      calculatePay({ receiptNo: this.receiptNo, ids })
        .then((res) => {
          if (res.data.success) {
            this.form.amount = res.data.data.needPayAmount
            this.form.ids = ids
          }
        })
        .catch((err) => {
          this.$message.error("获取需支付金额出错")
        })
    },

    savePayForB2B() {
      this.saveLoading = true
      b2bPay({
        receiptNo: this.receiptNo,
        ...this.form,
        payType: this.form.paymentType,
      })
        .then((res) => {
          this.saveLoading = false
          this.dialogVisible1 = false
          window.open(res.data.data)
        })
        .catch((e) => {
          this.saveLoading = false
        })
    },

    /** 缴费成功后的数据处理 */
    success() {
      this.saveLoading = false
      this.show = false
      this.$emit("refreshTable")
      this.$message({
        type: "success",
        message: "操作成功!",
      })
      this.onLoad()
    },
    /** 打开退款信息dialog */
    refund(id, type) {
      this.refundForm.id = id
      this.actionType = type
      this.showRefundDialog = true
    },

    /** 退款dialog取消事件 */
    handleCancle() {
      this.showRefundDialog = false
      Object.keys(this.refundForm).forEach((key) => (this.refundForm[key] = ""))
    },

    /** 退款信息提交事件 */
    handleConfirm() {
      this.$refs.refundForm.validate((valid) => {
        if (valid) {
          let d = Object.assign(this.refundForm)
          if (this.actionType == "1") {
            delete d.invoice_date
          } else {
            delete d.pay_atta_ids
            delete d.pay_remark
            d.is_invoice = "2"
          }
          let o = {
            update: JSON.parse(JSON.stringify(d)),
            primaryKeyValue: this.refundForm.id,
            primaryKey: "id",
          }
          updateMetaCommon("wisdom_park.wp_payment", o).then((res) => {
            if (res.data.success) {
              this.$message.success(this.actionType == "1" ? "录入成功" : "开票信息已录入")
              this.onLoad()
              this.handleCancle()
            }
          })
        }
      })
    },
  },
}
</script>
